import React from "react";
import { useRouteError } from "react-router-dom";
import { Button } from "../components/ui/Button";

const ErrorPage: React.FC = () => {
  const error = useRouteError() as { statusText?: string; message?: string };

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Oops! Something went wrong.</h1>
      <p>{error?.statusText || error?.message || "Unexpected error occurred."}</p>
      {/* <Button onClick={() => window.location.reload()} label={"Reload"} role={"dark"} size={"small"}>Reload</Button> */}
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
};

export default ErrorPage;
